/**
 * @module: 任务mobx
 * @author: xiongsha
 * @date: 2019-10-26 11:18:57
 */
import { observable, action, flow, toJS } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import { Toast } from 'antd-mobile';
import { ITaskProps, ITaskComment, ITaskList, IProject } from '@src/entity/company/task';
import { IMembersSel, IMemberNew } from '@src/entity/company/project';
import { memberNew2MembersSel } from '@src/utils/mapping';
import company from '.';
import { IOssFile } from '@src/utils/upload';
import ywk from '@clouderwork/ywk';
import Axios from 'axios';

interface ITaskParams {
  // task请求信息接口
  mode: number; // 1-我负责和参与的任务 2-我负责的 3-我参与的任务 4-我创建的任务 5-我关注的任务
  is_self?: number; // 0为我的任务 1为我的下属
  members_uuid?: string; // 下属的uuid
  departments_uuid?: string; // 下属部门的uuid
  category: number; // ('1', '任务'),(2, '需求'),'3', 'BUG'),(4, '风险') 默认为1
  priority?: number; // 1-不重要不紧急 2-紧急但不重要 3- 重要不紧急 4-重要且紧急
  status: number; // 1 是未完成, 2 已延期, 3 已完成, 0 是全部 默认是1
  project_id?: number; // 项目id
  follower?: string; // 参与人的uuid
  executor?: string; // 负责人的uuid
}

interface ISearchTask {
  keyword: string;
  pagenum: number;
}

class Task {
  //  筛选抽屉
  // @observable filterDrawer: boolean = false
  // 检查项抽屉
  // @observable cklistDrawer: boolean = false
  // 添加检查项抽屉
  // @observable ckaddDrawer: boolean = false
  // 添加评论抽屉
  // @observable cmaddDrawer: boolean = false
  //  项目抽屉
  // @observable projectDrawer: boolean = false
  //  标签抽屉
  // @observable tabDrawer: boolean = false
  // 记录请求情况
  @observable loading: boolean = false;

  // 任务类型
  @observable category: number = 1;
  // 任务
  @observable taskList: ITaskList[] = [];
  // 任务列表总数
  @observable taskListNum: number = 0;
  // 任务筛选状态 1 是未完成, 2 已延期, 3 已完成, 0 是全部 默认是1
  @observable status: number = 1;
  // 任务优先级
  @observable priority: number | undefined = undefined;
  // 任务归属 0为自己，1为下属
  @observable isSelf: number = 0;
  // 指派人（负责人）
  @observable executorUser: IMembersSel | undefined;
  // 关注人（参与人）
  @observable followerUser: IMembersSel | undefined;
  @observable projectId: number | undefined;
  // 创建人
  @observable creator_ids: string = '';
  // 类型 1-我负责和参与的项目 2-我负责的 3-我参与的 4-我创建的 5-我下属的 不传默认1
  @observable mode: number = 1;
  // 当前查看的任务
  @observable curTask: ITaskProps | null = null;
  // 当前任务的评论数据
  @observable comments: ITaskComment[] = [];

  // 编辑任务描述抽屉
  @observable descDrawer: boolean = false;
  // 项目
  @observable projects: IProject[] = [];
  // 下属人员
  @observable allowPerson: IMembersSel[] = [];
  // 下属人员请求
  @observable allowPersonLoad: boolean = false;
  // 是否从详情返回
  @observable isFromDetail: boolean = false;
  // 是否从详情返回
  @observable listSearch: { keyword: string; search: boolean } = { keyword: '', search: false };
  // 用于cancel ajax请求
  @observable source;
  // 记录当前缓存的数据
  @observable taskDataMap = {};
  // 设置loading
  @action.bound
  setLoading(val: boolean) {
    this.loading = val;
  }
  @action.bound
  setProject(val: number) {
    // 设置项目
    this.projectId = val;
    // const index = this.projectId.indexOf(val)
    // if (index > -1) {
    //   this.projectId.splice(index, 1)
    // } else {
    //   this.projectId.push(val)
    // }
  }

  @action.bound
  setFilter(name: string, val: (number | string)[] | string | undefined) {
    // 设置筛选状态设或置负责人和指派人
    this[name] = val;
  }

  // @action.bound
  // changeDrawer(name: string, val: boolean) {
  //   // 设置抽屉显示隐藏
  //   this[name] = val
  // }

  @action.bound
  setCategory = (val: number) => {
    // 设置任务类型
    this.category = val;
  };

  @action.bound
  async getTaskByOrigin(params: ITaskParams) {
    const key = JSON.stringify(params);
    if (this.taskDataMap[key]) return this.taskDataMap[key];
    // 阻止上一个请求
    if (this.source) {
      console.log(key, 'canceled');
      this.source.cancel();
    }
    this.source = Axios.CancelToken.source();
    // 获取任务
    try {
      const axiosRes: any = await Axios.get('/company/api/tasks/app', {
        cancelToken: this.source.token,
        params
      });
      console.log(key, 'getTaskByOrigin');
      const { data: res } = axiosRes;
      // this.loading = true;
      if (res.error_code === 0) {
        this.taskDataMap[key] = res.result;
        return this.taskDataMap[key];
      } else {
        Toast.fail(res.msg, 1);
      }
    } catch (error) {}
  }

  @action.bound
  async getTask(params: ITaskParams, isPull = false) {
    const key = await JSON.stringify(params);

    if (isPull) {
      this.taskDataMap[key] = undefined;
    }
    const cache = await this.getTaskByOrigin(params);
    if (!cache) return;
    this.loading = true;
    this.taskList = cache;
    const len = this.taskList.length;
    setTimeout(() => {
      this.taskListNum = len;
    }, 500);
    return this.backTips(1, len, 10);
  }

  // 根据关键字搜索任务
  @action.bound
  searchTask = flow(function* (this: Task, params: ISearchTask) {
    // let type: number = 3
    // switch (this.category) {
    //   case 1:
    //     type = 4
    //     break;
    //   case 2:
    //     type = 5
    //     break;
    //   case 4:
    //     type = 6
    //     break;
    //   default:
    //     type = 3;
    // }
    try {
      const res: any = yield ajax.post('/company/api/projects/search', {
        keyword: params.keyword,
        task: 1,
        category: this.category,
        is_self: 0
      });
      this.loading = true;
      if (res.error_code === 0) {
        // const data = res.data.filter((cur) => {
        //   return cur.category === this.category
        // })
        this.taskList = res.result.tasks_list;
        setTimeout(() => {
          this.taskListNum = res[this.category + '_count'];
        }, 500);
        return this.backTips(params.pagenum, res.count, 10);
      } else {
        Toast.fail(res.msg, 1);
      }
    } catch (error) {}
  });
  @action.bound
  setData(pagenum: number, key: string, data: any[]) {
    if (pagenum > 1) {
      this[key] = toJS(this[key]).concat(toJS(data));
    } else {
      this[key] = toJS(data);
    }
  }

  @action.bound
  backTips(pagenum: number, total: number, pageSize: number) {
    if (pagenum === 1) {
      return Promise.resolve('刷新成功');
    } else if (total < pagenum * pageSize) {
      return Promise.resolve('已经到底了');
    }
  }

  /** 修改属性值 */
  @action.bound
  setProperyVal(key: string, val: any) {
    this[key] = val;
  }

  /** 获取任务评论 */
  @action.bound
  async getTaskComments(taskId: number, pagenum: number) {
    const res = await ajax.getJson(`/company/api/tasks/comment/${taskId}`);
    if (res.error_code === 0) {
      this.comments = res.result;
      // 提示
      return this.backTips(pagenum, res.count, 5);
    } else {
      Toast.fail(res.msg, 1);
    }
  }

  /** 获取下属成员 */
  @action.bound
  async getAllowPerson(uuid: string) {
    const res = await ajax.getJson(`/company/api/project/members/manage-scopes`, { pagesize: 2000, pagenum: 1 });
    this.allowPersonLoad = true;
    if (res.error_code === 0) {
      this.allowPerson = memberNew2MembersSel(res.result) as IMembersSel[];
    } else {
      Toast.fail(res.msg, 1);
    }
  }

  /**
   * @param {number} mode 查询的类型 1-我负责和参与的项目 2-我关注的项目 3-我创建的项目 4-我下属的项目 不传默认1
   */
  @action.bound
  getProject = flow(function* (this: Task, mode: number) {
    // 获取我参与和我负责的项目
    this.loading = false;
    try {
      const res: any = yield ajax.getJson('/company/api/projects', {
        mode
      });
      this.loading = true;
      if (res.error_code === 0) {
        this.projects = res.result;
      } else {
        Toast.fail(res.msg, 1);
      }
      return res;
    } catch (error) {
      return error;
    }
  });

  /** 修改当前激活的任务属性 */
  @action.bound
  setCurTaskPropery(obj) {
    this.curTask = Object.assign({}, this.curTask, obj);
  }

  /** 修改任务列表属性 */
  @action.bound
  setTaskListPropery(index, name, val) {
    let taskList: ITaskList[] = Object.assign([], this.taskList);
    taskList[index][name] = val;
    this.taskList = taskList;
  }

  /** 获取当前激活的任务 */
  @action.bound
  async getCurTask(id: number) {
    try {
      const res = await ajax.getJson(`/company/api/tasks/${id}`);
      if (res.error_code === 0) {
        this.curTask = res.result.task;
      } else {
        if (res.response && res.response.data) {
          Toast.fail(res.response.data.msg, 1);
        }
      }
    } catch (error) {}
  }
  /**
   * 发送任务消息
   */
  @action.bound
  async sendTaskMessage(data, project_id: string, content: string) {
    if (!this.curTask) return;
    const { id, keyword, category, subject, category_text, end_at, comment_num, attach_num, tags } = this.curTask;
    const params = {
      project_uuid: project_id,
      content: {
        id,
        keyword,
        category,
        subject,
        category_text,
        end_at,
        comment_num,
        attach_num,
        tags,
        project_name: this.curTask.project.name,
        slug: project_id
      }
      // subtype: 'card_project_task',
      // type: 'message',
      // push_title: '',
      // push_content: `${company.user.user.name}:[任务消息]`,
      // include_me: 1,
      // from: '4',
      // ref_id: project_id,
      // data
    };
    try {
      const res = await ajax.post(`/company/api/tasks/${this.curTask.id}/send-to-chat`, params);
      if (content) {
        await ajax.post(`/wokexin/api/v1/message.send?usergroup_id=${company.user.user.company_uuid}`, {
          subtype: 'text',
          type: 'message',
          data: {
            text: content
          },
          from: '4',
          ref_id: project_id
        });
      }
      if (+res.error_code !== 0) {
        Toast.fail(res.msg || res.message, 1);
      }
      return res;
    } catch (error) {}
  }

  // 任务详情添加文件
  @action.bound
  async addFile(file: IOssFile) {
    if (!this.curTask) return;
    // const attach = await taskCreation.postFile(file) as any;
    const result = await ajax.post(`/company/api/tasks/${this.curTask.id}/attach`, { attachment_id: [file.id] });

    if (+result.error_code !== 0) {
      Toast.fail(result.msg, 1);
      return;
    }
    this.setCurTaskPropery({ attachment: [...this.curTask.attachment, file] });
  }

  /** 删除附件 */
  @action.bound
  async delAttaCb(index: number) {
    const item = this.curTask!.attachment[index];
    const res = await ywk.ajax.deleteJson(`/company/api/tasks/${this.curTask!.id}/attach`, { attachment_id: item.id });
    if (res.error_code === 0) {
      Toast.success('删除成功', 1);
      const attas = Object.assign([], this.curTask!.attachment);
      attas.splice(index, 1);
      this.setCurTaskPropery({ attachment: attas });
    } else {
      Toast.fail(res.msg || res.message, 1);
    }
  }
}

export default Task;
